import { ColorRangeFormatting, HexColor } from '@ardoq/api-types';
import { scaleColor } from '@ardoq/color-helpers';
import { isNil } from 'lodash';

const COLOR_SCALE_STEPS = 5;

export type CompleteColorRange = ColorRangeFormatting & {
  min: { value: number; color: string };
  max: { value: number; color: string };
};

/** Build a color scale with 5 preview colors based on the formatting */
export const buildColorScale = (colorRange: CompleteColorRange): HexColor[] => {
  const { min, mid, max } = colorRange;

  if (isNil(min.value) || isNil(max.value)) {
    return [];
  }

  if (mid && !isNil(mid.value)) {
    const midValue = mid.value;
    const midRange1 = midValue - min.value;
    const midRange2 = max.value - midValue;

    return [
      scaleColor(colorRange, min.value),
      scaleColor(colorRange, min.value + midRange1 * 0.5),
      scaleColor(colorRange, midValue),
      scaleColor(colorRange, midValue + midRange2 * 0.5),
      scaleColor(colorRange, max.value),
    ];
  }

  const range = max.value - min.value;
  return Array.from({ length: COLOR_SCALE_STEPS }, (_, i) =>
    scaleColor(colorRange, min.value + (range * i) / (COLOR_SCALE_STEPS - 1))
  );
};
